import React from 'react';

import { Popper, PopperProps } from '@lyearn/ui';

export const PopperOverride = function (props: PopperProps) {
  return <Popper {...props} />;
};
